import React from 'react';
// import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutFormClass from './CheckoutFormClass';
import { buildHeaders, generateUrlApiV2 } from '../../util/helpers/MiddlewareHelpers';

// const stripePromise = loadStripe("pk_test_51QN6GJATju0bEN1NciMxXG5GK0ShyRGHWo18S6SimNdef5LIDWoscvELWTaGPwPj7BKGS8oD1xiUCvQXDcXT5aAZ00IhEZMt8c");

export default class Checkout extends React.Component {
  state = { clientSecret: null, orderId: null, retrievalToken: null, error: null };

  componentDidMount() {
    console.log('check-newone', this.props);
    let idUnique = localStorage.getItem(`${this.props.compData.id}-idOptin`);
    if (idUnique) {
      const headers = buildHeaders();
      const url = generateUrlApiV2(`/cw-payment/create-payment-intent`);
      // fetch('http://localhost:3000/sandbox/cw-payment/create-payment-intent', {
      fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify({ amount: 2000, currency: 'usd', uuid: idUnique,
          idComp: this.props.compData.id }),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data.error) return this.setState({ error: data.error });
          this.setState({ clientSecret: data.clientSecret });
        })
        .catch((err) => this.setState({ error: err.message }));
    }
  }

  render() {
    const { clientSecret, orderId, retrievalToken, error } = this.state;
    let idUnique = localStorage.getItem(`${this.props.compData.id}-idOptin`);
    if (error) return <div style={{ color: 'red' }}>Error: {error}</div>;
    if (!clientSecret) return <div>Loading…</div>;

    return (
      <div className='checkout-form'>
        <Elements stripe={this.props.stripePromise} options={{ clientSecret }}>
          <CheckoutFormClass dCode={this.props.dCode} compData={this.props.compData}
            uuid={idUnique} orderId={orderId} retrievalToken={retrievalToken} />
        </Elements>
      </div>
    );
  }
}
